import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about5">

      {/* ======================================================
          SECTION 1 — EARTH SPLIT INTRO
      ======================================================= */}
      <section className="ab-intro">
        <div className="ab-left">
          <h1>Rooted In Balance,<br />Evolved Through Strength</h1>
          <p>
            At EARTHFIT, training isn’t rushed — it’s rhythmic.  
            We believe fitness should feel natural, intuitive,  
            and connected to the way the body was designed to move.
          </p>
        </div>

        <div className="ab-right">
          <img 
            src="https://images.pexels.com/photos/4325466/pexels-photo-4325466.jpeg"
            alt="earthfit about"
          />
        </div>
      </section>



      {/* ======================================================
          SECTION 2 — EARTH PHILOSOPHY PILLARS
      ======================================================= */}
      <section className="ab-pillars">
        <div className="pillar">
          <h2>Grounded Movement</h2>
          <p>
            Functional patterns inspired by nature’s stability  
            — helping you move confidently every day.
          </p>
        </div>

        <div className="pillar">
          <h2>Natural Strength</h2>
          <p>
            Build power at a sustainable pace without forceful,  
            high-impact routines.
          </p>
        </div>

        <div className="pillar">
          <h2>Mindful Awareness</h2>
          <p>
            Every rep begins with breath. Each session reconnects  
            you with focus and presence.
          </p>
        </div>
      </section>



      {/* ======================================================
          SECTION 3 — ORGANIC FLOW PANEL
      ======================================================= */}
      <section className="ab-flow">
        <div className="flow-inner">
          <h1>Our Approach<br />Feels Different</h1>
          <p>
            With EARTHFIT, movement becomes fluid,  
            aligned, and deeply restorative — a natural extension  
            of your lifestyle and wellbeing.
          </p>
        </div>
      </section>



      {/* ======================================================
          SECTION 4 — TEAM / VALUES GRID
      ======================================================= */}
      <section className="ab-values">
        <div className="value-item">
          <img 
            src="https://images.pexels.com/photos/6455772/pexels-photo-6455772.jpeg"
            alt="team"
          />
          <h3>Certified Coaches</h3>
          <p>Experts in natural biomechanics & functional strength.</p>
        </div>

        <div className="value-item">
          <img 
            src="https://images.pexels.com/photos/8436601/pexels-photo-8436601.jpeg"
            alt="community"
          />
          <h3>Community First</h3>
          <p>A welcoming culture built on support, not comparison.</p>
        </div>

        <div className="value-item">
          <img 
            src="https://images.pexels.com/photos/6339325/pexels-photo-6339325.jpeg"
            alt="environment"
          />
          <h3>Eco-Inspired Space</h3>
          <p>Natural textures, calm tones, and grounded energy.</p>
        </div>
      </section>



      {/* ======================================================
          SECTION 5 — EARTH BANNER QUOTE
      ======================================================= */}
      <section className="ab-banner">
        <blockquote>
          “Movement becomes powerful when it’s connected to breath  
          and anchored in intention.”
        </blockquote>
      </section>



      {/* ======================================================
          SECTION 6 — EARTH OUTRO PANEL
      ======================================================= */}
      <section className="ab-outro">
        <h2>Move With Purpose</h2>
        <p>
          EARTHFIT helps you return to balance — physically, mentally,  
          and naturally.
        </p>

        <div className="outro-soil s1"></div>
        <div className="outro-soil s2"></div>
      </section>

    </div>
  );
};

export default About;
